import { VariantPackCostType } from '@/types';

export type SalesRepInfoCostMap = { [type in VariantPackCostType]?: number };

/**
 * The pricing tables show (variant pack, restaurant) pairs nested under a
 * parent row; the grouping is which of the two the parent stands for.
 */
export enum PricingGroupBy {
  Restaurant = 'restaurant',
  VariantPack = 'variantPack',
}
